var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptyIllustration = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 128 128",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 64,
  r: 64,
  fill: "#17171E"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 64,
  r: 63.5,
  stroke: "white",
  strokeOpacity: 0.05
})), /*#__PURE__*/React.createElement("path", {
  d: "M19.5039 51.0703L36.4027 17.2136C37.0798 15.8571 38.4656 15 39.9817 15H88.9822C90.5306 15 91.94 15.8937 92.6003 17.2944L108.522 51.0703",
  stroke: "white",
  strokeOpacity: 0.06,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 46,
  y: 9,
  width: 36,
  height: 34,
  rx: 4,
  fill: "url(#tasks-empty-paint0_linear_0_4)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 46.5,
  y: 9.5,
  width: 35,
  height: 33,
  rx: 3.5,
  stroke: "white",
  strokeOpacity: 0.05
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M41 21C41 18.7909 42.7909 17 45 17H83C85.2091 17 87 18.7909 87 21V47C87 49.2091 85.2091 51 83 51H45C42.7909 51 41 49.2091 41 47V21Z",
  fill: "url(#tasks-empty-paint1_linear_0_4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45 17.5H83C84.933 17.5 86.5 19.067 86.5 21V47C86.5 48.933 84.933 50.5 83 50.5H45C43.067 50.5 41.5 48.933 41.5 47V21C41.5 19.067 43.067 17.5 45 17.5Z",
  stroke: "white",
  strokeOpacity: 0.05
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M36 31C36 28.7909 37.7909 27 40 27H88C90.2091 27 92 28.7909 92 31V57C92 59.2091 90.2091 61 88 61H40C37.7909 61 36 59.2091 36 57V31Z",
  fill: "url(#tasks-empty-paint2_linear_0_4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 27.5H88C89.933 27.5 91.5 29.067 91.5 31V57C91.5 58.933 89.933 60.5 88 60.5H40C38.067 60.5 36.5 58.933 36.5 57V31C36.5 29.067 38.067 27.5 40 27.5Z",
  stroke: "white",
  strokeOpacity: 0.05
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M29 41C29 38.7909 30.7909 37 33 37H95C97.2091 37 99 38.7909 99 41V67C99 69.2091 97.2091 71 95 71H33C30.7909 71 29 69.2091 29 67V41Z",
  fill: "url(#tasks-empty-paint3_linear_0_4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33 37.5H95C96.933 37.5 98.5 39.067 98.5 41V67C98.5 68.933 96.933 70.5 95 70.5H33C31.067 70.5 29.5 68.933 29.5 67V41C29.5 39.067 31.067 37.5 33 37.5Z",
  stroke: "white",
  strokeOpacity: 0.05
})), /*#__PURE__*/React.createElement("rect", {
  x: 41,
  y: 51,
  width: 46,
  height: 2,
  rx: 1,
  fill: "white",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 58,
  width: 48,
  height: 2,
  rx: 1,
  fill: "white",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("rect", {
  x: 49,
  y: 44,
  width: 31,
  height: 2,
  rx: 1,
  fill: "white",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#tasks-empty-filter0_d_0_4)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#tasks-empty-clip0_0_4)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M40.6826 51.5C41.9367 51.5 43.0949 52.1709 43.7188 53.2588L49.4131 63.1914C50.2152 64.5903 51.7049 65.4531 53.3174 65.4531H74.6826C76.2951 65.4531 77.7848 64.5903 78.5869 63.1914L84.2812 53.2588C84.866 52.2391 85.9204 51.5857 87.083 51.5078L87.3174 51.5H108.5V90C108.5 96.3513 103.351 101.5 97 101.5H31C24.6487 101.5 19.5 96.3513 19.5 90V51.5H40.6826Z",
  fill: "#23232F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.6826 51.5C41.9367 51.5 43.0949 52.1709 43.7188 53.2588L49.4131 63.1914C50.2152 64.5903 51.7049 65.4531 53.3174 65.4531H74.6826C76.2951 65.4531 77.7848 64.5903 78.5869 63.1914L84.2812 53.2588C84.866 52.2391 85.9204 51.5857 87.083 51.5078L87.3174 51.5H108.5V90C108.5 96.3513 103.351 101.5 97 101.5H31C24.6487 101.5 19.5 96.3513 19.5 90V51.5H40.6826Z",
  fill: "url(#tasks-empty-paint4_linear_0_4)",
  fillOpacity: 0.99
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.6826 51.5C41.9367 51.5 43.0949 52.1709 43.7188 53.2588L49.4131 63.1914C50.2152 64.5903 51.7049 65.4531 53.3174 65.4531H74.6826C76.2951 65.4531 77.7848 64.5903 78.5869 63.1914L84.2812 53.2588C84.866 52.2391 85.9204 51.5857 87.083 51.5078L87.3174 51.5H108.5V90C108.5 96.3513 103.351 101.5 97 101.5H31C24.6487 101.5 19.5 96.3513 19.5 90V51.5H40.6826Z",
  stroke: "#2A2A36"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.4,
  clipPath: "url(#tasks-empty-clip1_0_4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M93.1749 69.3549L112.78 91.2124L110.228 101.038L100.408 103.14L94.3007 95.6132L104.19 93.496L103.642 92.8573L91.1519 78.3269L90.5718 77.6511L90.297 78.4989L87.4236 87.3843L81.6595 80.506L84.2072 71.2749L93.1749 69.3549ZM87.2511 87.9176L87.4313 88.1297L93.5355 95.3326L85.2153 97.114L82.4986 106.479L76.027 99.0812L78.8953 89.6496L87.271 87.8564L87.2511 87.9176Z",
  fill: "url(#tasks-empty-paint5_linear_0_4)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M101 71.5L102.052 76.4478L107 77.5L102.052 78.5522L101 83.5L99.9478 78.5522L95 77.5L99.9478 76.4478L101 71.5Z",
  fill: "#767694"
}))), /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 89,
  width: 27,
  height: 3,
  rx: 1.5,
  fill: "white",
  fillOpacity: 0.05
}), /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 83,
  width: 21,
  height: 3,
  rx: 1.5,
  fill: "white",
  fillOpacity: 0.05
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "tasks-empty-filter0_d_0_4",
  x: 11.7,
  y: 47.7,
  width: 104.6,
  height: 65.6,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.65
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0843505 0 0 0 0 0.0843505 0 0 0 0 0.115291 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_0_4"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_0_4",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "tasks-empty-paint0_linear_0_4",
  x1: 64,
  y1: 9,
  x2: 64,
  y2: 43,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#414150"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#161619"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "tasks-empty-paint1_linear_0_4",
  x1: 64,
  y1: 17,
  x2: 64,
  y2: 51,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#414150"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#161619"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "tasks-empty-paint2_linear_0_4",
  x1: 64,
  y1: 27,
  x2: 64,
  y2: 61,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#414150"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#161619"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "tasks-empty-paint3_linear_0_4",
  x1: 64,
  y1: 37,
  x2: 64,
  y2: 67.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#414150"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1F1F2B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "tasks-empty-paint4_linear_0_4",
  x1: 57,
  y1: 44.5,
  x2: 64,
  y2: 104.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.104309,
  stopColor: "#15151D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.516172,
  stopColor: "#23232F",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#15151D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "tasks-empty-paint5_linear_0_4",
  x1: 84.9979,
  y1: 66.0003,
  x2: 104.998,
  y2: 102,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.17
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#414151"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "tasks-empty-clip0_0_4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 51H109V90C109 96.6274 103.627 102 97 102H31C24.3726 102 19 96.6274 19 90V51Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "tasks-empty-clip1_0_4"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white",
  transform: "translate(69.2561 71.6303) rotate(-12.0846)"
})))));
export default SvgEmptyIllustration;